import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import annualsummary from "../assets/images/My_machine.svg";
import DemoLogo from "../assets/images/quantummain.svg";
import crossarrow from "../assets/images/crossarrow.svg";
import toprightimg from "../assets/images/marketplace-top-right.png";
import stars from "../assets/images/stars.svg";
import { commonservices, CountCharacter } from "../services/CommonServices";
import Loader, { LoaderType } from "./common-component/Loader";
import Nodata from "./common-component/Nodata";
import { useDispatch, useSelector } from "react-redux";
import { MachinePurchaseList } from "../services/ReduxTookit/Slice/MachineRedux";

function Mypurchase() {
  const dispatch = useDispatch();
  const [MachineLoader, setMachineLoader] = useState(false);
  const [MachineList, setMachineList] = useState([]);
  let navigate = useNavigate();

  async function getMachineList() {
    setMachineLoader(true);
    dispatch(MachinePurchaseList()).then((res) => {
      if (res?.payload?.isValidate) {
        setMachineList(res?.payload?.data?.data?.dataList1);
        setMachineLoader(false);
      }
      if (!res?.payload?.isValidate) {
        setMachineList([]);
      }
    });
  }
  useEffect(() => {
    getMachineList();
  }, []);

  return (
    <div className="dashboard-main market-place-page-main">
      <div className="all-page-top">
        <Container>
          <div className="top-section-all">
            <div className="top-section-left">
              <div className="d-flex align-items-center gap-3 mb16">
                <h1 className="mb-0">Explore My Purchase</h1>
                {/* <Link to="/marketplace/addMachine" className="green-btn">
                  Add New Machine
                </Link> */}
              </div>
              <p>
                Review and manage the tools and services you’ve acquired. Keep
                track of your purchases, access detailed information, and
                discover how they can continue adding value to your operations.
              </p>
            </div>
            <div className="top-section-right top-purchase">
              <img
                src={toprightimg}
                alt="top-right-img"
                className="top-section-right-img"
              />
            </div>
          </div>
        </Container>
      </div>
      <div className="main-page-content purchase-main">
        <Container>
          <div className="all-marketplace-wrapper">
            <Row>
              <Col xl={12} className="my-4">
                {MachineLoader ? (
                  <>
                    <Loader type={LoaderType.Widgets} count={6} />
                  </>
                ) : (
                  <div>
                    {MachineList?.length > 0 ? (
                      <>
                        <div className="all-market-place-main">
                          {MachineList?.map((item_m, index_m) => (
                            <>
                              <div
                                key={index_m}
                                className="single-market-place-main"
                              >
                                <div className="d-flex align-items-center justify-content-between">
                                  <div className="single-market-place-img">
                                    <img
                                      src={
                                        item_m?.machinelogo !== "" &&
                                        item_m?.machinelogo !== null
                                          ? item_m?.machinelogo
                                          : DemoLogo
                                      }
                                      alt={item_m?.machinename}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = DemoLogo;
                                      }}
                                    />
                                  </div>

                                  <h3 className="report-price-single">
                                    {item_m?.price > 0
                                      ? `$ ${(item_m?.price).toFixed(2)}`
                                      : "Free"}
                                  </h3>
                                </div>
                                <div className="market-place-content">
                                  <div className="market-place-content-title d-block">
                                    <span className="blue-badge">
                                      {item_m?.categoryname}
                                    </span>
                                    <h4
                                      className="d-block"
                                      title={item_m?.machinename}
                                    >
                                      {commonservices.truncateText(
                                        item_m?.machinename,
                                        CountCharacter.MachineName
                                      )}
                                    </h4>
                                    {item_m?.avgrating > 0 && (
                                      <div className="market-place-content-ratings">
                                        <img src={stars} alt="stars" />
                                        <span>
                                          {item_m?.avgrating.toFixed(1)}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: item_m?.shortdescription
                                        ? commonservices.truncateText(
                                            commonservices.stripHTML(
                                              item_m.shortdescription
                                            ),
                                            CountCharacter.MachineShortDetail
                                          )
                                        : "",
                                    }}
                                  />
                                  <div className="d-flex align-items-end justify-content-between">
                                    <div className="developer-name">
                                      <span className="developer">
                                        Developer
                                      </span>
                                      <Link
                                        to="/marketplace/developer"
                                        state={{
                                          subscriberId: item_m?.subscriberid,
                                        }}
                                      >
                                        {item_m?.subscribername}
                                      </Link>
                                    </div>
                                    <Link
                                      // to={`${`/marketplace/marketplace-detail/${item_m?.machineid}`}`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        navigate(
                                          `/marketplace/marketplace-detail/${commonservices.bodyEncryption(String(item_m?.machineid))}/Marketplace`
                                        );
                                      }}
                                      className="crossarrow ms-auto"
                                    >
                                      <img src={crossarrow} alt="crossarrow" />
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </>
                          ))}
                        </div>
                      </>
                    ) : (
                      <Nodata />
                      // <div>No Data found.</div>
                    )}
                  </div>
                )}
                {/* </Row> */}
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default Mypurchase;
